import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import API from "../axios";

const VehiclesWithoutSpec = () => {
    const params = new URLSearchParams(window.location.search);
    const [page, setPage] = useState<number>(Number(params.get("page")) || 1);

    const [limit] = useState(10); // Should match backend default
    const [filters, setFilters] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [vehicles, setVehicles] = useState<Array<any>>([]);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [active, setActive] = useState("true");

    const updateQueryParams = (updates: Record<string, string>) => {
        const url = new URL(window.location.href);
        Object.entries(updates).forEach(([key, value]) => {
            if (!value || value === "null" || value === "undefined") {
                url.searchParams.delete(key);
            } else {
                url.searchParams.set(key, value);
            }
        });
        window.history.pushState({}, "", url);
    };

    const loadVehiclesFromUrl = async () => {
        const paramsUrl = new URLSearchParams(window.location.search);
        const currentPage = Number(paramsUrl.get("page")) || 1;
        const currentSearchString = paramsUrl.get("searchString") || "";

        const query: any = {
            page: currentPage,
            limit,
            active,
        };

        // Always include search string if present
        if (currentSearchString) {
            query.searchString = currentSearchString;
        }

        setLoading(true);
        try {
            const result: any = await API.paginateVehicleWithoutSpec(query);
            console.log(result.data);

            setVehicles(result.data);
            setPage(currentPage);
            setTotalPages(result.pagination.totalPages);
            setTotalItems(result.pagination.total);

            // Update filters for display
            setFilters({
                ...(query.searchString && { searchString: query.searchString }),
            });
        } catch (error) {
            console.error("Failed to load vehicles:", error);
        } finally {
            setLoading(false);
        }
    };

    const goToPage = async (newPage: number) => {
        if (newPage < 1 || newPage > totalPages) return;

        updateQueryParams({
            page: newPage.toString(),
        });

        await loadVehiclesFromUrl();
    };

    // Load data on initial render
    useEffect(() => {
        loadVehiclesFromUrl();
    }, []);

    useEffect(() => {
        loadVehiclesFromUrl();
    }, [active]);

    return (
        <div>
            <Container style={{ marginTop: 100 }}>
                <Row>
                    <Col xs="10" className="d-flex align-items-center gap-2">
                        <a
                            className="btn btn-outline-black btn-md mx-1"
                            href={`/vehicles`}
                        >
                            <i className="bi bi-chevron-left fs-4"></i>
                        </a>
                        <h3 className="fw-medium text-primary">
                            Vehicles Without Specification
                        </h3>
                    </Col>
                    <Col xs="2" className="text-end">
                        <Row className="g-2">
                            <Col xs="12" className="mt-3">
                                <label className="form-label">
                                    Visiable On Website
                                </label>
                                <select
                                    className="form-select"
                                    value={active}
                                    onChange={(e) => setActive(e.target.value)}
                                >
                                    <option selected value="true">
                                        Public Vehicles
                                    </option>
                                    <option value="false">
                                        Hidden Vehicles
                                    </option>
                                </select>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col cols="12" className="d-flex justify-content-end"></Col>
                </Row>
                <Row className="mt-5">
                    {loading ? (
                        /* LOADING */
                        <div
                            className="d-flex justify-content-center align-items-center my-5"
                            style={{ minHeight: "50vh" }}
                        >
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </div>
                        </div>
                    ) : vehicles.length === 0 ? (
                        /* NO DATA */
                        <div
                            className="d-flex flex-column justify-content-center align-items-center text-muted"
                            style={{ minHeight: "50vh" }}
                        >
                            <i className="bi bi-inbox fs-1 mb-3"></i>
                            <h5 className="fw-medium">No Result </h5>
                            <p className="mb-0">
                                All published vehicles have specification
                            </p>
                        </div>
                    ) : (
                        /* TABLE */
                        <>
                            <table className="table mt-3">
                                <thead>
                                    <tr>
                                        <th>Image</th>
                                        <th>Title</th>
                                        <th>Available For Sale</th>
                                        <th>Forecased Stock</th>
                                        <th>Edit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {vehicles.map((vehicle, index) => (
                                        <tr key={index}>
                                            <td>
                                                <img
                                                    src={
                                                        vehicle.productImage ||
                                                        "/images/no-image.png"
                                                    }
                                                    width={80}
                                                    height={60}
                                                    className="rounded-2"
                                                    alt={vehicle.title}
                                                />
                                            </td>
                                            <td className="fw-normal">
                                                {vehicle.title}
                                            </td>
                                            <td>
                                                <strong>
                                                    {vehicle.validStock}
                                                </strong>
                                            </td>
                                            <td>
                                                <strong>
                                                    {vehicle.forecastedStock}
                                                </strong>
                                            </td>
                                            <td>
                                                <a
                                                    className="btn btn-outline-primary btn-sm mx-1"
                                                    href={`/vehicle/${vehicle._id}`}
                                                >
                                                    <i className="bi bi-pencil"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {/* PAGINATION ONLY WHEN DATA EXISTS */}
                            <nav
                                aria-label="Page navigation"
                                style={{ marginBottom: 200 }}
                            >
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        Showing {(page - 1) * limit + 1} to{" "}
                                        {Math.min(page * limit, totalItems)} of{" "}
                                        {totalItems} vehicles
                                    </div>

                                    <ul className="pagination">
                                        <li
                                            className={`page-item ${
                                                page <= 1 ? "disabled" : ""
                                            }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => goToPage(1)}
                                                disabled={page <= 1}
                                            >
                                                First
                                            </button>
                                        </li>
                                        <li
                                            className={`page-item ${
                                                page <= 1 ? "disabled" : ""
                                            }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() =>
                                                    goToPage(page - 1)
                                                }
                                                disabled={page <= 1}
                                            >
                                                Previous
                                            </button>
                                        </li>

                                        {/* Page numbers - show up to 5 around current page */}
                                        {totalPages > 0 &&
                                            Array.from(
                                                {
                                                    length: Math.min(
                                                        5,
                                                        totalPages
                                                    ),
                                                },
                                                (_, i) => {
                                                    let pageNum: number;
                                                    if (totalPages <= 5) {
                                                        pageNum = i + 1;
                                                    } else if (page <= 3) {
                                                        pageNum = i + 1;
                                                    } else if (
                                                        page >=
                                                        totalPages - 2
                                                    ) {
                                                        pageNum =
                                                            totalPages - 4 + i;
                                                    } else {
                                                        pageNum = page - 2 + i;
                                                    }

                                                    return (
                                                        <li
                                                            key={i}
                                                            className={`page-item ${
                                                                page === pageNum
                                                                    ? "active"
                                                                    : ""
                                                            }`}
                                                        >
                                                            <button
                                                                className="page-link"
                                                                onClick={() =>
                                                                    goToPage(
                                                                        pageNum
                                                                    )
                                                                }
                                                            >
                                                                {pageNum}
                                                            </button>
                                                        </li>
                                                    );
                                                }
                                            )}

                                        <li
                                            className={`page-item ${
                                                page >= totalPages
                                                    ? "disabled"
                                                    : ""
                                            }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() =>
                                                    goToPage(page + 1)
                                                }
                                                disabled={page >= totalPages}
                                            >
                                                Next
                                            </button>
                                        </li>
                                        <li
                                            className={`page-item ${
                                                page >= totalPages
                                                    ? "disabled"
                                                    : ""
                                            }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() =>
                                                    goToPage(totalPages)
                                                }
                                                disabled={page >= totalPages}
                                            >
                                                Last
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </>
                    )}
                </Row>
            </Container>
        </div>
    );
};

export default VehiclesWithoutSpec;
